/**
 * Overview share-grants table render helpers (FE-5b) — extracted from overview.route.js.
 */

/**
 * @param {object[]} items
 * @returns {object[]}
 */
export function sortOverviewShareGrantRows(items) {
  return [...(Array.isArray(items) ? items : [])].sort((a, b) => {
    const c = String(a.device_id || "").localeCompare(String(b.device_id || ""));
    return c !== 0 ? c : String(a.grantee_username || "").localeCompare(String(b.grantee_username || ""));
  });
}

/**
 * @param {object[]} rows
 * @param {object[]} devices
 * @param {(v: unknown) => string} canonicalGroupKey
 * @returns {string}
 */
export function buildOverviewShareGrantsStatLine(rows, devices, canonicalGroupKey) {
  const list = Array.isArray(rows) ? rows : [];
  if (!list.length) return "No active shares — group summary is empty.";
  const byDid = new Map((Array.isArray(devices) ? devices : []).map((d) => [String(d.device_id), d]));
  const devIds = new Set(list.map((row) => String(row.device_id || "").trim()).filter(Boolean));
  const ndev = devIds.size;
  const gkeys = new Set();
  let mapped = 0;
  for (const did of devIds) {
    const d = byDid.get(did);
    if (!d) continue;
    mapped += 1;
    const k = canonicalGroupKey(d.notification_group || "");
    if (k) gkeys.add(k);
  }
  const aclN = list.length;
  if (mapped < ndev) {
    const cacheNote = mapped === 0
      ? "group names not in this sample yet"
      : `group names from ${mapped} of ${ndev} boards loaded`;
    return `${aclN} share${aclN === 1 ? "" : "s"} · ${ndev} board${ndev === 1 ? "" : "s"} · ${cacheNote}. Open a group card for day-to-day work.`;
  }
  return `${aclN} share${aclN === 1 ? "" : "s"} · ${ndev} board${ndev === 1 ? "" : "s"} · ${gkeys.size} group${gkeys.size === 1 ? "" : "s"}.`;
}

/**
 * @param {object[]} rows
 * @param {(s: string) => string} escapeHtml
 * @returns {string}
 */
export function buildOverviewShareGrantsTableHtml(rows, escapeHtml) {
  const body = (Array.isArray(rows) ? rows : []).map((it) => {
    const did = escapeHtml(String(it.device_id || ""));
    const gu = escapeHtml(String(it.grantee_username || ""));
    const v = it.can_view ? "✓" : "—";
    const o = it.can_operate ? "✓" : "—";
    return `<tr data-device-id="${did}" data-grantee="${gu}">
          <td class="mono">${did}</td>
          <td class="mono">${gu}</td>
          <td>${v}</td>
          <td>${o}</td>
          <td style="white-space:nowrap">
            <button type="button" class="btn sm secondary js-share-grant-edit">Edit</button>
            <button type="button" class="btn sm danger js-share-grant-revoke">Revoke</button>
          </td>
        </tr>`;
  }).join("");
  return `<div class="table-wrap"><table class="t"><thead><tr><th>Device</th><th>Shared with</th><th>View</th><th>Operate</th><th>Actions</th></tr></thead><tbody>${body}</tbody></table></div>`;
}
